import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const Header = () => {
  return <header className="bg-white" data-id="element-453">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-454"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-455">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-456">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-457">
            MEDPRESS GAZETTE
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-458">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-459">
          <div className="text-left" data-id="element-460">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-461">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-462">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-463">
        <div className="max-w-4xl mx-auto" data-id="element-464">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-465">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-466">
            Dermatology Nurse Investigates: Do Red Light Therapy Caps Actually
            Regrow Hair, or Is It Another Wellness Scam?
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-467">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-468">
              <img src="https://cdn.magicpatterns.com/uploads/pgHF1VNF6Whvw8QDg83TjW/31.png" alt="Margaret Weiss" className="w-full h-full object-cover" data-id="element-469" />
            </div>
            <div className="flex-1" data-id="element-470">
              <div className="flex items-center" data-id="element-471">
                <div className="font-medium text-gray-900 text-lg" data-id="element-472">
                  By Margaret Weiss, RN, MSN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-473">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-474" />
                  <span className="text-xs ml-1 font-medium" data-id="element-475">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-476">
                Former Head of Integrative Dermatology, Cedar Sinai Medical
                Center
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-477">
                <div className="flex items-center mr-4" data-id="element-478">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-479" />
                  <span data-id="element-480">11 min read</span>
                </div>
                <div className="flex items-center" data-id="element-481">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-482" />
                  <span data-id="element-483">24,867 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-484">
            After 30 years in medicine, I've seen every "hair growth miracle"
            come and go. So when patients started asking about red light therapy
            caps, I decided to run a 12-month investigation. What I discovered
            will save you thousands of dollars – and might actually save your
            hair.
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-485">
            <div className="mb-1 flex items-center" data-id="element-486">
              <span className="font-medium mr-2" data-id="element-487">Published by:</span>
              MedPress Gazette Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-488">
              <span className="font-medium mr-2" data-id="element-489">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-490">
        <div className="max-w-4xl mx-auto" data-id="element-491">
          <div className="sm:flex items-center" data-id="element-492">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-493">
              <img src="https://cdn.magicpatterns.com/uploads/pgHF1VNF6Whvw8QDg83TjW/31.png" alt="Margaret Weiss, RN, MSN in hospital corridor" className="w-full rounded-lg shadow-md" data-id="element-494" />
            </div>
            <div className="sm:w-2/3" data-id="element-495">
              <p className="text-sm text-gray-700 mb-2" data-id="element-496">
                <span className="font-bold" data-id="element-497">Margaret Weiss, RN, MSN</span> has
                spent three decades in clinical practice specializing in
                integrative dermatology and trichology. As the former Head of
                Integrative Dermatology at Cedar Sinai Medical Center, she has
                evaluated hundreds of hair loss treatments and devices
                throughout her career.
              </p>
              <p className="text-sm text-gray-700" data-id="element-498">
                Her investigative work focuses on separating evidence-based
                treatments from marketing hype, helping patients make informed
                decisions based on clinical testing rather than trends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;